"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable */
var _default = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  d: "M4.5 6.5c0 .7207.2179 1.3906.5913 1.9473C2.8215 9.3075 2 11.4084 2 14.75c0 1.5.5 2.25 1.5 2.25h.6762c.1155-.7365.2893-1.4027.5254-2h-.6952A4.7144 4.7144 0 014 14.75c0-3.2688.6838-4.47 3.0002-4.7049L7 10c0-.75.1651-1.4613.461-2.0998C6.8988 7.6837 6.5 7.1384 6.5 6.5 6.5 5.6716 7.1716 5 8 5c.5677 0 1.0617.3153 1.3164.7804a4.9694 4.9694 0 011.8767-.7156C10.6452 3.8475 9.4216 3 8 3 6.067 3 4.5 4.567 4.5 6.5zm16 10.5h-.6762c-.1155-.7365-.2893-1.4027-.5254-2h.6952A4.7212 4.7212 0 0020 14.75c0-3.2688-.6838-4.47-3.0002-4.7049L17 10c0-.75-.1651-1.4613-.461-2.0998.5622-.2165.961-.7618.961-1.4002 0-.8284-.6716-1.5-1.5-1.5-.5677 0-1.0617.3153-1.3165.7804a4.9687 4.9687 0 00-1.8766-.7156C13.3548 3.8475 14.5785 3 16 3c1.933 0 3.5 1.567 3.5 3.5a3.4832 3.4832 0 01-.5913 1.9473C21.1785 9.3075 22 11.4084 22 14.75c0 1.5-.5 2.25-1.5 2.25zM6.75 22C5.5833 22 5 21.1667 5 19.5c0-3.8103 1.0093-6.1687 3.8184-7.0754A3.9824 3.9824 0 018 10c0-2.2091 1.7909-4 4-4 2.2091 0 4 1.7909 4 4a3.982 3.982 0 01-.8184 2.4246C17.9907 13.3313 19 15.6897 19 19.5c0 1.6667-.5833 2.5-1.75 2.5H6.75zM14 10c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2zm3 9.5c0 .2139-.0122.3804-.0272.5H7.0272C7.0122 19.8804 7 19.7139 7 19.5c0-4.2064 1.1303-5.5 5-5.5s5 1.2936 5 5.5z",
  clipRule: "evenodd"
})), 'UserGroupsIcon');
/* eslint-enable */


exports["default"] = _default;